module.exports = __webpack_public_path__ + "img/new-logo.f6a066e7.png";